import { useRouter } from 'next/navigation';

import Typography from '@components/Typography';
import CustomIcon from '@components/utils/CustomIcon';
import { SmilingStar } from '@assets/icons';
import useGetasPath from '@hooks/useGetasPath';

import {
  EventsRowDesktop,
  EventsBadgeWrapper,
  OpportunityBadgeWrapper,
} from './styled';
export interface MemberOpportunityProps {
  hasEvents?: boolean;
  memberOpportunity?: boolean;
  membershipPrice?: boolean;
  setIsRedirecting?: (value: boolean) => void;
}
const MemberOpportunityHotel = ({
  hasEvents,
  memberOpportunity,
  membershipPrice,
  setIsRedirecting,
}: MemberOpportunityProps) => {
  const asPath = useGetasPath();
  const router = useRouter();
  const OnClick = () => {
    router.push(`/giris-yap?redirectUrl=${encodeURIComponent(asPath)}`);
    setIsRedirecting?.(true);
  };
  return (
    <EventsRowDesktop>
      {hasEvents ? (
        <EventsBadgeWrapper>
          <CustomIcon fontSize={16} icon={SmilingStar} />
          <Typography
            color='NL0'
            variant='caption2'
            weight='SemiBold'
            style={{ textAlign: 'right', width: '82px' }}
          >
            Etkinlikli Otel
          </Typography>
        </EventsBadgeWrapper>
      ) : null}
      {membershipPrice ? (
        <OpportunityBadgeWrapper>
          <Typography
            color='NL0'
            variant='caption2'
            weight='SemiBold'
            style={{ textAlign: 'right' }}
          >
            Üyelere Özel
          </Typography>
        </OpportunityBadgeWrapper>
      ) : (
        <>
          {memberOpportunity ? (
            <OpportunityBadgeWrapper onClick={OnClick}>
              <Typography
                color='NL0'
                variant='caption2'
                weight='SemiBold'
                style={{ textAlign: 'right' }}
              >
                Üyelere Özel Fiyat için Giriş Yap
              </Typography>
            </OpportunityBadgeWrapper>
          ) : null}
        </>
      )}
    </EventsRowDesktop>
  );
};

export default MemberOpportunityHotel;
